import Highcharts from 'highcharts';
import { BaseChartOptions, HighchartsOptions } from '../highcharts-options';

/**
 * @deprecated Please use {@link ChartOptionsBuilder}
 */
export default class PortfolioTotalsChartOptions {
  /**
   * @deprecated Please use {@link ChartOptionsBuilder}
   */
  static getChartOptions(): HighchartsOptions {
    const baseOptions = BaseChartOptions.getEmptyChartOptions();
    const chartOptions: HighchartsOptions = {
      ...baseOptions,
      chart: {
        type: 'bar',
      },
      plotOptions: {
        series: {
          stacking: 'normal',
        },
      },
      title: {
        text: '',
      },
      xAxis: {
        ...baseOptions.xAxis,
        categories: [],
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        stackLabels: {
          enabled: true,
          formatter() {
            return Highcharts.numberFormat(this.total, 2);
          },
        },
      },
      legend: {
        enabled: true,
        reversed: true,
      },
      exporting: {
        enabled: false,
      },
      credits: {
        text: 'pacemaker.ai',
        href: ' https://pacemaker.ai/',
      },
      tooltip: {
        useHTML: true,
        headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
        pointFormatter() {
          return (
            '<tr><td style="color: ' +
            this.series.color +
            '">' +
            this.series.name +
            '</td>' +
            '<td style="text-align: right"><b>' +
            Highcharts.numberFormat(this.y ?? 0, 2) +
            '</b></td></tr>'
          );
        },
        footerFormat: '</table>',
        shared: true,
      },
      series: [],
    };

    return chartOptions;
  }
}
